import { isItemOfMessageType } from 'owa-mail-list-store';
import listViewStore from 'owa-mail-list-store/lib/store/Store';
import { ReactionsContainer } from 'owa-mail-reactions-view';
import { mailStore } from 'owa-mail-store';
import ReactListViewType from 'owa-service/lib/contract/ReactListViewType';
import * as React from 'react';
import type Message from 'owa-service/lib/contract/Message';

export default function renderReactions(params: {
    backgroundColorClass: string;
    isFirstLevelExpanded: boolean;
    isSecondLevelExpanded: boolean;
    latestItemId: string;
    reactionsContainerClassName: string;
    rowId: string;
    tableViewId: string;
}): JSX.Element | null {
    const {
        backgroundColorClass,
        isFirstLevelExpanded,
        isSecondLevelExpanded,
        latestItemId,
        reactionsContainerClassName,
        rowId,
        tableViewId,
    } = params;

    const isRowExpanded = isFirstLevelExpanded || isSecondLevelExpanded;
    const tableView = listViewStore.tableViews.get(tableViewId);
    // @ts-expect-error
    const isItemView = tableView.tableQuery.listViewType === ReactListViewType.Message;
    const item = isItemView ? mailStore.items.get(rowId) : mailStore.items.get(latestItemId);

    if (isRowExpanded || !item || !isItemOfMessageType(item)) {
        return null;
    }

    return (
        <div className={reactionsContainerClassName}>
            <ReactionsContainer
                // @ts-expect-error
                conversationId={{
                    ...item.ConversationId,
                    mailboxInfo: item.MailboxInfo,
                }}
                // @ts-expect-error
                itemId={{
                    ...item.ItemId,
                    mailboxInfo: item.MailboxInfo,
                }}
                message={item as Message}
                // @ts-expect-error
                instrumentationContext={null}
                isInMessageList={true}
                backgroundColorClass={backgroundColorClass}
            />
        </div>
    );
}
